import { MortgageCategory } from "./constants";
import { LoanRate } from "./LoanRate";

export default function getAmortizationTypes(rateId: LoanRate, mortgageCategory: MortgageCategory, isBalloon: boolean): string[] {
    if (isBalloon ||
        rateId === LoanRate.FIXED_40_YEAR_RATE_WITH_15_YEAR_BALLOON ||
        rateId === LoanRate.LOT_20_YEAR_LOAN_WITH_7_YEAR_BALLOON ||
        rateId === LoanRate.FIXED_30_YEAR_SECOND_MORTGAGE_WITH_15_YEAR_BALLOON
    ) {
        return [ "Balloon" ];
    }
    if (mortgageCategory === MortgageCategory.ARM) {
        return [ "ARM" ];
    }
    if (rateId === LoanRate.FIRST_TIME_HOMEBUYER_7_6_ADJUSTABLE_RATE_MORTGAGE) {
        return [ "ARM", "Balloon", "OptionArm" ];
    }
    return ["Fixed"];
}